import { ReportSection } from '../../../types'
import { ConfigSection, AnomalyReport } from '../../../../../shared/types'
import getDetailReportSections from './getDetailReportSections'
import getInsightReportSections from './getInsightReportSections'
import { addReportSectionCols } from '../../../utils/sections'

type ReportSectionProps = {
  report: AnomalyReport
  reportUrl?: string
  history?: any
  location?: any
  configSections?: ConfigSection[]
}

export default function generateReportSections(props: ReportSectionProps): ReportSection[] {
  const { report, reportUrl, history, location, configSections } = props
  const { reportMetadata, reportDetailData } = report

  const reportEndDate = reportMetadata.reportPeriod.endDate

  const reportSections: ReportSection[] = []

  const insightReportSections = getInsightReportSections({
    report,
    reportUrl,
    history,
    location,
    configSections,
  })

  reportSections.push(...insightReportSections)

  if (reportDetailData.reports) {
    const detailReportSections = getDetailReportSections({
      reports: reportDetailData.reports,
      configSections,
      reportEndDate,
      history,
      location,
      reportUrl,
    })

    reportSections.push(...detailReportSections)
  }

  // loop through report sections, generate/standardize/merge dataSection columns
  return addReportSectionCols(reportSections)
}
